import React from "react";
import {
  Alert,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import { Link } from "react-router-dom";
import BotaoSuporte from "../../../Components/Common/BotaoSuporte";

//import images
import progileBg from "../../../assets/images/profile-bg.jpg";

// AIDEV-NOTE: Administrative customer registration suspended; displays support contact and link back to client list
const ClientesCadastro = () => {
  document.title = "Novo Cadastro | Painel Fort Exchange";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="position-relative mx-n4 mt-n4">
            <div className="profile-wid-bg profile-setting-img">
              <img src={progileBg} className="profile-wid-img" alt="" />
              <div className="overlay-content">
                <div className="text-end p-3">
                  <div className="p-0 ms-auto rounded-circle profile-photo-edit"></div>
                </div>
              </div>
            </div>
          </div>
          <Row>
            <Col xxl={12}>
              <Card className="mt-xxl-n5">
                <CardBody className="p-4">
                  <TabContent activeTab="1">
                    <TabPane tabId="1">
                      <div className="p-3">
                        <Alert color="warning" className="text-center mb-4">
                          <h6 className="alert-heading fw-bold mb-1">
                            Cadastro de novos clientes desativado
                          </h6>
                          <p className="mb-0">
                            O cadastro de novos clientes está temporariamente desativado no sistema. Em caso de dúvidas, entre em contato com o suporte.
                          </p>
                        </Alert>
                        <div className="text-center">
                          <BotaoSuporte
                            className="btn btn-success"
                            texto="Falar com o suporte"
                            mensagem="Olá, gostaria de suporte sobre o cadastro de clientes."
                          />
                          <Link to="/clientes" className="btn btn-light ms-2">
                            Voltar para Clientes
                          </Link>
                        </div>
                      </div>
                    </TabPane>
                  </TabContent>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ClientesCadastro;
